import * as React from "react";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

import Coded from "@material-ui/icons/Code";
import Love from "@material-ui/icons/Favorite";

import { Text } from "./components";

type ClassNames = "container" | "icon";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        display: "flex",
        padding: theme.spacing.unit * 4,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#fafafa"
    },
    icon: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit
    }
});

class Footer extends React.Component<WithStyles<ClassNames> & {}> {
    public render() {
        const {classes} = this.props;
        return (
            <footer className={classes.container}>
                <Coded className={classes.icon} />
                <Text variant="important" gutterBottom={false}>with</Text>
                <Love className={classes.icon} />
                <Text variant="important" gutterBottom={false}>in Zürich</Text>
            </footer>
        );
    }
}

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./src/Footer.tsx